export class Company {
  constructor(data) {
    const localData = data || {};

    this.uuid = localData.uuid;
    this.commercial_name = localData.commercial_name;
    this.fiscal_name = localData.fiscal_name;
    this.fiscal_number = localData.fiscal_number;
    this.country = localData.country;
    this.address = localData.address;
    this.address_details = localData.address_details;
    this.phone = localData.phone;
    this.size = localData.size;
    this.company_fleets = localData.fleets;
    this.allows_personal_use = localData.allows_personal_use_open;
    this.allows_business_use_open = localData.allows_business_use_open;
    this.allows_personal_use_dedicated = localData.allows_personal_use_dedicated;
    this.allows_business_use_dedicated = true;
    this.address_street_3 = localData.address_street_3;
    this.allow_carpooling = !!localData.allow_carpooling;
    this.cs_operator_uuid = localData.cs_operator;
    this.dedicated_cs_operator_uuid = localData.dedicated_fleet_cs_operator;
    this.cost_allocation = localData.cost_allocation || false;
    this.mandatory_cost_allocation = localData.mandatory_cost_allocation;
  }

  static create(attr) {
    return new Company(attr);
  }
}

export default Company;
